import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import { IoClose } from "react-icons/io5";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import Switch from "react-switch";

const ManageInterest = () => {
  ChangeTitle("Manage Interest");
  const [isProfessionModalOpen, setIsProfessionModalOpen] = useState(false);
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false);
  const [professionList, setProfessionList] = useState([]);
  const [interestList, setInterestList] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState("");
  const [selectedInterest, setSelectedInterest] = useState([]);

  // Profession List  API Call
  const viewProfessionList = async () => {
    const param = {};
    var response = await postData("profession/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          id: data._id,
          title: data.professionName,
        };
      });
      setProfessionList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Interest List  API Call
  const viewInterestList = async () => {
    const param = {};
    var response = await postData("interest/list", param, apiHeader(false));
    console.log("response", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          id: data._id,
          title: data.interestName,
        };
      });
      setInterestList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Profession Add
  const addProfession = async (id) => {
    const param = {
      profession: id,
    };
    var response = await postData(
      "private/user/profession",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      getProfession();
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  //  Interest Add
  const addInterest = async (data) => {
    const param = {
      interest: data,
    };
    var response = await postData(
      "private/user/interest",
      param,
      apiHeader(false)
    );

    console.log("add interest response", response, param);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      getInterest();
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Profession Selected Get
  const getProfession = async () => {
    const param = {};
    var response = await getData(
      "private/user/select/profession",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setSelectedProfession(data.profession);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Interest Selected Get
  const getInterest = async () => {
    const param = {};
    var response = await getData(
      "private/user/select/interest",
      param,
      apiHeader(false)
    );

    console.log("interest", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data[0];
      setSelectedInterest(data.interest || []);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewProfessionList();
    viewInterestList();
    getProfession();
    getInterest();
  }, []);

  // Function to toggle selection and update API
  const handleToggle = async (id) => {
    let updatedSelections = [];

    if (Array.isArray(selectedInterest) && selectedInterest.includes(id)) {
      // Remove from selection if already present
      updatedSelections = selectedInterest.filter((pid) => pid !== id);
    } else {
      // Add to selection if not present
      updatedSelections = [...selectedInterest, id];
    }

    setSelectedInterest(updatedSelections);
    console.log("updatedSelections", updatedSelections);

    // Send updated array to the API
    await addInterest(updatedSelections);
  };

  // Opem Modal Popup Form Function
  const openModal = (type) => {
    document.body.style.overflowY = "hidden";
    if (type == "profession") {
      setIsProfessionModalOpen(true);
    } else if (type == "interest") {
      setIsInterestModalOpen(true);
    }
  };

  // Close Modal Popup Form Function
  const closeModal = (type) => {
    document.body.style.overflowY = "";
    if (type == "profession") {
      setIsProfessionModalOpen(false);
    } else if (type == "interest") {
      setIsInterestModalOpen(false);
    }
  };
  return (
    <>
      {isProfessionModalOpen === true && (
        <>
          <div
            onClick={() => closeModal("profession")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[6%] relative  transform form-box"
            >
              <div className="flex mb-[3rem] lg:mb-[5rem] items-center justify-between">
                <h1 className="hanson">Select your profession</h1>
                <IoClose
                  onClick={() => closeModal("profession")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="h-[85vh] lg:h-[75vh] xl:h-[60vh] overflow-y-auto pr-[1rem] sec-popup-box-scroll">
                {professionList.map((data) => (
                  <div className="flex justify-between gap-10 mb-[2rem]">
                    <h1 className="interest-title">{data.title}</h1>
                    <Switch
                      checked={selectedProfession == data.id || false}
                      onChange={() => addProfession(data.id)}
                      onColor="#c99930"
                      offColor="#E6E6E6"
                      uncheckedIcon={false}
                      checkedIcon={false}
                      handleDiameter={20}
                      height={24}
                      width={48}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      {isInterestModalOpen === true && (
        <>
          <div
            onClick={() => closeModal("interest")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] relative transform form-box "
            >
              <div className="flex mb-[3rem] lg:mb-[5rem] items-center justify-between">
                <h1 className="hanson">Area of interest</h1>
                <IoClose
                  onClick={() => closeModal("interest")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="h-[85vh] lg:h-[75vh] xl:h-[60vh] overflow-y-auto pr-[1rem] sec-popup-box-scroll">
                {interestList.map((data) => (
                  <div className="flex justify-between gap-10 mb-[2rem]">
                    <h1 className="interest-title">{data.title}</h1>
                    <Switch
                      checked={
                        Array.isArray(selectedInterest) &&
                        selectedInterest.includes(data.id)
                      }
                      onChange={() => handleToggle(data.id)}
                      onColor="#c99930"
                      offColor="#E6E6E6"
                      uncheckedIcon={false}
                      checkedIcon={false}
                      handleDiameter={20}
                      height={24}
                      width={48}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Manage interest
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full">
            <div className="flex gap-5 mb-[3rem] justify-between items-center p-[1.5rem] lg:p-[3rem] manage-interest-box">
              <div>
                <h1 className="mib-title">Select your profession</h1>
                <p className="mib-title2">Chartered accountant</p>
              </div>
              <div>
                <button
                  type="button"
                  onClick={() => openModal("profession")}
                  className="h-full btn-change"
                >
                  Change
                </button>
              </div>
            </div>
            <div className="flex gap-5 justify-between items-center p-[1.5rem] lg:p-[3rem] manage-interest-box">
              <div>
                <h1 className="mib-title">Area of interest</h1>
                <p className="mib-title2">
                  Income tax, international taxation, insolvency & bankruptcy,
                  FEMA, banking & insurance...
                </p>
              </div>
              <div>
                <button
                  type="button"
                  onClick={() => openModal("interest")}
                  className="btn-change"
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageInterest;
